import React from 'react';
import { Visibility as VisibilityOn, VisibilityOff } from '@mui/icons-material';

/**
 * A visibility toggle icon component that switches between visible and hidden states.
 *
 * @param {Object} props - Component props
 * @param {boolean} [props.visible=true] - Whether to show the "visible" or "hidden" icon
 * @param {string} [props.className] - CSS class name for styling
 * @param {React.CSSProperties} [props.style] - Inline styles object
 * @param {() => void} [props.onClick] - Click event handler
 * @param {string} [props.color] - Icon color ('inherit' | 'primary' | 'secondary' | 'action' | 'error' | 'disabled')
 * @param {string} [props.fontSize] - Icon size ('inherit' | 'large' | 'medium' | 'small')
 * @param {string} [props.titleAccess] - Tooltip text
 * @param {React.Ref} [props.ref] - Ref forwarding to the icon element
 *
 * @example
 * // Basic usage
 * <Visibility visible={isPasswordVisible} />
 *
 * @example
 * // With click handler
 * <Visibility
 *   visible={showPassword}
 *   onClick={() => setShowPassword(!showPassword)}
 *   aria-label="Toggle password visibility"
 * />
 *
 * @example
 * // With custom styling
 * <Visibility
 *   visible={false}
 *   color="primary"
 *   fontSize="large"
 *   className="my-visibility-icon"
 * />
 */
export const Visibility = ({ visible = true, ...props }) => {
  if (!visible) {
    return <VisibilityOff {...props} />;
  }

  return <VisibilityOn {...props} />;
};
